import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import API_CONFIG from '../config/api';
import { logout } from './authSlice';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: API_CONFIG.BASE_URL,
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    let token = getState().auth.userInfo?.token; // Prefer Redux
    if (!token) {
      try {
        const stored = localStorage.getItem('userInfo');
        if (stored) {
          const parsed = JSON.parse(stored);
          token = parsed?.token || null;
        }
      } catch (e) {
        // ignore
      }
    }
    // Normalize tokens that might already include the Bearer prefix.
    if (typeof token === 'string' && token.startsWith('Bearer ')) {
      token = token.slice(7);
    }
    if (token && !headers.get('Authorization')) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const AUTH_FAILURE_PATHS = ['/api/user/auth', '/api/user/register'];

const isCredentialFailure = (args) => {
  const url = typeof args === 'string' ? args : args?.url;
  return AUTH_FAILURE_PATHS.some((path) => typeof url === 'string' && url.includes(path));
};

const baseQuery = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (result?.error?.status === 401 && !isCredentialFailure(args)) {
    api.dispatch(logout());
    if (window.location.pathname !== '/signin' && window.location.pathname !== '/signup') {
      window.location.href = '/signin';
    }
  }

  return result;
};
  

export const apiSlice = createApi({
  baseQuery,
  reducerPath: "api",
  tagTypes: [
    "User", 
    "WebsiteStats", 
    "UserAnalytics", 
    "ContentAnalytics", 
    "SurveyAnalytics", 
    "ExportData", 
    "ExportStats", 
    "DataQuality", 
    "DataQualityIssues", 
    "DataValidationRules", 
    "DataDomains", 
    "DomainData",
    "ActivityLog",
    "ConsumptionStats",
    "Notifications",
    "SiteTheme",
    "SystemSettings"
  ],
  endpoints: (builder) => ({

    //comment
  }),
});

